//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockCount', {
//        templateUrl: 'views/components/views/stockCount/stockCount.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'stockCountService', function ($stateParams, stateService, stockCountService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceId = $stateParams.stockplace_id;
//            let stockCountKeyno = $stateParams.stockcount_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await stockCountService.getEdit({
//                    stockplace_id: stockPlaceId,
//                    stockcount_keyno: stockCountKeyno
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                stockCountService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
